import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop Component
 * Scrolls to top of page on route change
 */
export const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to top on route change
    window.scrollTo(0, 0);
    // Feb 2026 · SPA-Nav-Counter für den zentralen useSmartBack-Hook.
    // Wir zählen jede Routenänderung, damit der Zurück-Button weiß, dass
    // eine echte In-App-Historie existiert (`document.referrer` ist bei
    // SPA-Navigationen leer).
    try {
      const key = 'hs.spa.nav.count';
      const prev = Number(sessionStorage.getItem(key) || '0');
      sessionStorage.setItem(key, String(prev + 1));
    } catch { /* private mode */ }
  }, [pathname]);

  return null;
};

export default ScrollToTop;
